import { takeLatest, call, all, put, fork } from 'redux-saga/effects'

import * as actions from '../../actions/actions'

import { banks, enableBank, disableBank } from "../../../api/bankApi"
import { push } from "connected-react-router";

export default function* bankSaga() {
  yield all([
    fork(watchFetchBanksRequest),
    fork(watchEnableBankRequest),
    fork(watchDisableBankRequest)
  ]);
}

function* watchFetchBanksRequest() {
  yield takeLatest(
    actions.FETCH_BANKS_REQUEST,
    fetchBanksRequest
  )
}

function* fetchBanksRequest() {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(banks)
    yield put({ type: actions.FETCH_BANKS_SUCCESS, banks: data })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {

    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_BANKS_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }

  }
}

function* watchEnableBankRequest() {
  yield takeLatest(
    actions.ENABLE_BANK_REQUEST,
    enableBankRequest
  )
}

function* enableBankRequest(bankData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(enableBank, bankData.value)
    yield put({ type: actions.ENABLE_BANK_SUCCESS, banks: data })
    yield put(push(`/bank`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.ENABLE_BANK_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
    }
  }
}

function* watchDisableBankRequest() {
  yield takeLatest(
    actions.DISABLE_BANK_REQUEST,
    disableBankRequest
  )
}

function* disableBankRequest(bankData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(disableBank, bankData.value)
    yield put({ type: actions.DISABLE_BANK_SUCCESS, banks: data })
    yield put(push(`/bank`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.DISABLE_BANK_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_SERVER, error: error.response })

    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_CLIENT, error: error.response })
    }
  }
}